"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationMeasure = exports.Measures = void 0;
const rounding_method_1 = require("./rounding-method");
exports.Measures = {
    Accrual: { type: 'ACCRUAL', typeOfValue: 'AMOUNT', roundingMethod: 'NEAREST', roundingDecimals: 2 },
    EIR: { type: 'EIR', typeOfValue: 'RATE', roundingMethod: 'DOWN', roundingDecimals: 8, noOfIterations: 100, toleranceAmount: .01 },
    RealizedInterest: { type: 'REALIZED_INTEREST', typeOfValue: 'AMOUNT', roundingMethod: 'NEAREST', roundingDecimals: 2 },
    WAL: { type: 'WAL', typeOfValue: 'RATE', roundingMethod: 'DOWN', roundingDecimals: 8 },
    MACAULAY_DURATION: { type: 'MACAULAY_DURATION', typeOfValue: 'RATE', roundingMethod: 'DOWN', roundingDecimals: 8 },
};
class ValuationMeasure {
    constructor() {
    }
    static getMeasure(measureName) {
        const valuationMeasure = new ValuationMeasure();
        switch (measureName) {
            case 'ACCRUAL':
                valuationMeasure.measure = exports.Measures.Accrual;
                break;
            case 'EIR':
                valuationMeasure.measure = exports.Measures.EIR;
                break;
            case 'REALIZED_INTEREST':
                valuationMeasure.measure = exports.Measures.RealizedInterest;
                break;
            case 'WAL':
                valuationMeasure.measure = exports.Measures.WAL;
                break;
            case 'MACAULAY_DURATION':
                valuationMeasure.measure = exports.Measures.MACAULAY_DURATION;
                break;
        }
        return valuationMeasure;
    }
    round(calculatedAmount) {
        const rounding = rounding_method_1.Rounding.getRounding(this.measure.roundingMethod, this.measure.roundingDecimals);
        return rounding.round(calculatedAmount);
    }
    toleranceAmount() {
        if (this.measure.toleranceAmount) {
            return this.measure.toleranceAmount;
        }
        return 0;
    }
    noOfIterations() {
        if (this.measure.noOfIterations) {
            return this.measure.noOfIterations;
        }
        return 0;
    }
}
exports.ValuationMeasure = ValuationMeasure;
//# sourceMappingURL=valuation-measure.js.map